var React = require('react');

function Avatar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.573,22.588,21.534,20.52a.713.713,0,0,1-.449-.658V18.684a.669.669,0,0,1,.142-.418,9.918,9.918,0,0,0,2.065-6.036C23.292,8.5,20.924,6,17.4,6s-5.892,2.5-5.892,6.23a9.92,9.92,0,0,0,2.065,6.036.668.668,0,0,1,.142.418v1.178a.713.713,0,0,1-.449.658L8.227,22.588A3.564,3.564,0,0,0,6,25.89v1.96a.95.95,0,0,0,.95.95h20.9a.95.95,0,0,0,.95-.95V25.89A3.564,3.564,0,0,0,26.573,22.588ZM26.9,26.9H7.9V25.89a1.671,1.671,0,0,1,1.049-1.544l5.039-2.068a2.606,2.606,0,0,0,1.628-2.416V18.684a2.574,2.574,0,0,0-.561-1.608,8.075,8.075,0,0,1-1.646-4.846c0-3.193,2.062-4.33,3.992-4.33s3.992,1.137,3.992,4.33a8.075,8.075,0,0,1-1.646,4.846,2.575,2.575,0,0,0-.561,1.608v1.178a2.606,2.606,0,0,0,1.628,2.416l5.038,2.068A1.671,1.671,0,0,1,26.9,25.89Z","transform":"translate(-6 -6)"}));
}

Avatar.defaultProps = {"viewBox":"0 0 22.8 22.8"};

module.exports = Avatar;

Avatar.default = Avatar;
